import { Routes, Route } from "react-router-dom";
import { Suspense, lazy } from "react";
import NotFound from "./NotFound";

/* -------- Lazy Load Pages -------- */

const Home = lazy(() => import("../components/home"));
const Career = lazy(() => import("../components/pages/Career"));
const Contact = lazy(() => import("../components/pages/Contact"));
const WhoWeAre = lazy(() => import("../components/pages/WhoWeAre"));

// const Blogs = lazy(() =>
//   import("../components/pages/pagess/insights/blogs")
// );

const EndUserManaged = lazy(() =>
  import("../components/pages/pagess/whatwedo/endusermanaged")
);
const AnnualDims = lazy(() =>
  import("../components/pages/pagess/whatwedo/annualdims")
);
const ApplicationManaged = lazy(() =>
  import("../components/pages/pagess/whatwedo/applicationmanaged")
);
const GlobalDelivery = lazy(() =>
  import("../components/pages/pagess/whatwedo/globaldelivery")
);

const HybridCloud = lazy(() =>
  import("../components/pages/pagess/whatwedo/hybridcloud")
);
const EndUserAmc = lazy(() =>
  import("../components/pages/pagess/whatwedo/enduseramc")
);
const CiscoPoweredManaged = lazy(() =>
  import("../components/pages/pagess/whatwedo/ciscopoweredmanaged")
);
const CiscoMeraki = lazy(() =>
  import("../components/pages/pagess/whatwedo/ciscomeraki")
);
const CiscoCatalyst = lazy(() =>
  import("../components/pages/pagess/whatwedo/ciscocatalyst")
);

const InfsEndUser = lazy(() =>
  import("../components/pages/pagess/whatwedo/infsenduser")
);
const InfsDataCenter = lazy(() =>
  import("../components/pages/pagess/whatwedo/infsdatacenter")
);
const InfsMeeting = lazy(() =>
  import("../components/pages/pagess/whatwedo/infsmeeting")
);

const StaffPeopleDevelopment = lazy(() =>
  import("../components/pages/pagess/whatwedo/staffpeopledevelopment")
);

const CyberEndPoint = lazy(() =>
  import("../components/pages/pagess/whatwedo/cyberendpoint")
);
const CyberCloud = lazy(() =>
  import("../components/pages/pagess/whatwedo/cybercloud")
);
const CyberApplication = lazy(() =>
  import("../components/pages/pagess/whatwedo/cyberapplication")
);
const CyberNetwork = lazy(() =>
  import("../components/pages/pagess/whatwedo/cybernetwork")
);
const CyberOperational = lazy(() =>
  import("../components/pages/pagess/whatwedo/cyberoperational")
);

const CloudGoogle = lazy(() =>
  import("../components/pages/pagess/whatwedo/cloudgoogle")
);
const CloudAzure = lazy(() =>
  import("../components/pages/pagess/whatwedo/cloudazure")
);
const CloudManaged = lazy(() =>
  import("../components/pages/pagess/whatwedo/cloudmanaged")
);
const CloudAmazon = lazy(() =>
  import("../components/pages/pagess/whatwedo/cloudamazon")
);
const CloudMigration = lazy(() =>
  import("../components/pages/pagess/whatwedo/cloudmigration")
);

const ERPBusinessAnalyst = lazy(() =>
  import("../components/pages/pagess/whatwedo/erpbusinessanalyst")
);

const Retail = lazy(() =>
  import("../components/pages/pagess/Industries/retail")
);
const ItItes = lazy(() =>
  import("../components/pages/pagess/Industries/it-ites")
);

/* -------- Routes -------- */

function AppRoutes() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        {/* Main Pages */}
        <Route path="/" element={<Home />} />
        <Route path="/career" element={<Career />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/who-we-are" element={<WhoWeAre />} />

        {/* Insights */}
        {/* <Route path="/blogs" element={<Blogs />} /> */}
        {/* <Route path="/events" element={<Events />} /> */}

        {/* What We Do */}
        <Route path="/end-user-managed" element={<EndUserManaged />} />
        <Route path="/annual-dims" element={<AnnualDims />} />
        <Route path="/application-managed" element={<ApplicationManaged />} />
        <Route path="/global-delivery" element={<GlobalDelivery />} />
        <Route path="/hybrid-cloud" element={<HybridCloud />} />
        <Route path="/end-user-amc" element={<EndUserAmc />} />


        <Route path="/cisco-powered-managed" element={<CiscoPoweredManaged />} />
        <Route path="/cisco-meraki" element={<CiscoMeraki />} />
        <Route path="/cisco-catalyst" element={<CiscoCatalyst />} />

        <Route path="/infs-end-user" element={<InfsEndUser />} />
        <Route path="/infs-data-center" element={<InfsDataCenter />} />
        <Route path="/infs-meeting" element={<InfsMeeting />} />

        <Route path="/staff-people-development" element={<StaffPeopleDevelopment />} />

        {/* Cyber */}
        <Route path="/cyber-endpoint" element={<CyberEndPoint />} />
        <Route path="/cyber-cloud" element={<CyberCloud />} />
        <Route path="/cyber-application" element={<CyberApplication />} />
        <Route path="/cyber-network" element={<CyberNetwork />} />
        <Route path="/cyber-operational" element={<CyberOperational />} />

        {/* Cloud */}
        <Route path="/cloud-google" element={<CloudGoogle />} />
        <Route path="/cloud-azure" element={<CloudAzure />} />
        <Route path="/cloud-managed" element={<CloudManaged />} />
        <Route path="/cloud-amazon" element={<CloudAmazon />} />
        <Route path="/cloud-migration" element={<CloudMigration />} />

        {/* ERP */}
        <Route path="/erp-business-analyst" element={<ERPBusinessAnalyst />} />

        {/* Industries */}
        <Route path="/retail" element={<Retail />} />
        <Route path="/it-ites" element={<ItItes />} />

        {/* 404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
}

export default AppRoutes;
